import React, { useState, useContext, useEffect, useCallback } from "react";
import {
  FormLeaveGuard,
  LoaderWrapper,
  ManageMapperLayout,
  WarningModal,
} from "../../../components";
import { isEmpty, get, isNull } from "lodash";
import SourceContainer from "./SourceContainer";
import TargetContainer from "./TargetContainer";
import { DragDropContext } from "react-beautiful-dnd";
import { useHistory } from "react-router";
import { Container, Row, Col, Button, Modal } from "react-bootstrap";
import {
  manageMapperStore,
  setManageMapperToastInfo,
  setFileUploadData,
  setMapperPostRequest,
  setMapperPostResponse,
  MANAGE_MAPPER_POST_API_ERROR,
} from "../../../contexts";
import { Formik, isEmptyArray } from "formik";

import SampleData from "../MapperHomeContainer/SampleData";
import {
  MANAGE_MAPPER_ROUTES,
  CensusAndPayroll,
  Payroll,
  Census,
  FLOW_TYPES,
  ROUTES,
  getPathWithParam,
  passthroughStringToFunctionConverter,
  removePassthroughFieldTrans,
} from "../../../utils";
import {
  onMappingChange,
  savePassthroughMapAndTransform,
} from "../../../services";
import { useDeepEffect, useRouterParams } from "../../../abstracts";
import { getTargetDetails } from "../../../services";
import { default as uuid } from "uuid";
import { getMappings } from "../../../services/ai";
import PassthroughTargetContainer from "./PassthroughTargetContainer";
import { faTimes } from "@fortawesome/pro-light-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
const columns = {
  source: {
    id: "source container",
    title: "source",
    data: SampleData,
  },
};

const MapperContainer = (props) => {
  const { state, dispatch } = useContext(manageMapperStore);
  const { flow, profileId, mapType } = useRouterParams();
  const [list, setList] = useState([]);
  //const [children, setChildren] = useState([]);
  //const [gr, setGr] = useState([]);
  const isEdit = flow === FLOW_TYPES.EDIT;
  const [characters, setCharacters] = useState();
  const [isRequiredPassthrough, setIsRequiredPassthrough] = useState(false);
  const [showToast, setShowToast] = useState(false);
  const uploadedFileType = get(state, "api.data.uploadedFileType");
  const apiData = get(state, "api.data");
  const headersJson = get(state, "api.data.headerMapJson");
  const fileUpload = get(state, "api.fileuploadData", []);
  const fileuploadData = JSON.stringify(get(fileUpload, "row"));
  const objectMapDate = !isEmpty(get(apiData, "objectMaps"))
    ? get(apiData, "objectMaps")
    : get(fileUpload, "mappingConfiguration.objectMaps");
  const fileUploadFields = !isEmpty(fileuploadData)
    ? fileuploadData
    : get(fileUpload, "mappingConfiguration.headerMapJson", "");
  const fieldHeadersJson = isEmpty(fileUpload) ? headersJson : fileUploadFields;
  const [mapperenable, setmapperenable] = useState(enableAutomapper);
  const [dragStart, setDrag] = useState(false);
  const [addConfigureSlider, setConfigureSlider] = useState(false);
  const [dest, setDestination] = useState("");
  const [mapped, setMapped] = useState("");
  const [modalVisible, setModalVisible] = useState(false);
  // let alreadyTriggered = false;
  const mappingData = isEmpty(fileUpload)
    ? get(state, "api.data", [])
    : get(state, "api.fileuploadData.mappingConfiguration", []);
  const enableAutomapper = get(mappingData, "enableAutomapper", null);
  const [ssnExist, setSsnExist] = useState(true);
  const [rkPlanNumberExist, setRkPlanNumberExist] = useState(true);
  const [jsonPassthroughTargetFile, setJsonPassthroughTargetFile] = useState();
  const [searchList, setSearchList] = useState();
  const [targetList, setTargetList] = useState([]);
  const data = isEdit
    ? get(mappingData, "objectMaps", []).filter((e) => isEmpty(e.parent))
    : get(mappingData, "objectMaps", []);
  const [ct, setCT] = useState([]);
  const nonCollections = !isEmpty(data)
    ? data.filter((f) => !f.isCollection || !f.isComplex)
    : [];
  const targetData = list ? list : [];
  const children = [];
  const gr = [];
  const requiredObjects = targetData.map((e) => {
    const d = nonCollections.find((g) => g.propertyName == e.propertyName);
    if (!isEmpty(d)) {
      return {
        ...d,
        id: d.id.toString(),
        groupName: e.groupName,
        displayName: e.displayName,
      };
    }
    return e;
  });
  function processObject(obj) {
    const optionsModified = obj.options
      ?.split('"')
      .filter((str) => str.trim() !== "" && str !== ",");

    const childObjects = obj.childObjectMaps?.map((ob) => {
      return processObject({
        ...ob,
        id: ob.id.toString(),
        parentId: ob.parentId.toString(),
        childObjectMaps: ob.childObjectMaps ? ob.childObjectMaps : [],
      });
    });

    return {
      ...obj,
      options: optionsModified,
      fieldOperations: [],
      id: obj.id.toString(),
      childObjectMaps: childObjects ? childObjects : [],
    };
  }

  function processResponse(response) {
    const modifiedResponse = response.map(processObject);
    setList(modifiedResponse.filter((_) => _.parentId === null));
    setDataLoading(false);
  }
  useEffect(() => {
    if (!isEmpty(objectMapDate)) {
      setmapperenable(false);
    }
    setDataLoading(true);
    getTargetDetails(uploadedFileType)
      .then((response) => {
        if (response) {
          processResponse(response);
        }
      })
      .catch(() => {
        setDataLoading(false);
      });
  }, []);
  useDeepEffect(() => {
    try {
      const parseField = headersJson ?? fieldHeadersJson;
      if (!isEmpty(parseField)) {
        const parsedHeadersJson = JSON.parse(parseField);
        setCharacters(parsedHeadersJson);
      }
    } catch (error) {
      console.error("Error parsing JSON:", error);
      // Handle the error as needed
    }
  }, [fieldHeadersJson]);

  const collections = !isEmpty(data)
    ? data.filter((f) => f.isCollection || f.isComplex)
    : [];

  const processChildObjectMaps = (childMaps, existingChilds) => {
    if (!isEmpty(childMaps)) {
      return existingChilds.map((f) => {
        const d = childMaps.find((g) => g.propertyName === f.propertyName);
        if (!isEmpty(d)) {
          const nestedChildMaps = processChildObjectMaps(
            get(d, "childObjectMaps", []),
            f.childObjectMaps
          );
          return {
            ...d,
            id: d.id.toString(),
            displayName: f.displayName || get(d, "displayName"),
            childObjectMaps: nestedChildMaps,
            path: d.path,
          };
        }
        return f;
      });
    }
    return [];
  };

  const processCollections = (collections, targetData) => {
    return collections.map((e) => {
      const existingChilds = targetData.find(
        (g) => g.propertyName === e.propertyName
      );
      const childObjectMaps = processChildObjectMaps(
        e.childObjectMaps,
        get(existingChilds, "childObjectMaps", [])
      );
      return {
        ...e,
        id: e.id.toString(),
        groupName: get(existingChilds, "groupName"),
        childObjectMaps,
      };
    });
  };

  const requiredCollections = !isEmpty(collections)
    ? processCollections(collections, targetData)
    : [];

  const wholeObject = requiredObjects.filter((e) =>
    isEmpty(requiredCollections.find((g) => g.propertyName == e.propertyName))
  );
  const [dataLoading, setDataLoading] = useState(false);
  const [targetField, setTargetField] = useState(
    !isEmpty(wholeObject)
      ? [...wholeObject, ...requiredCollections]
      : targetData
  );
  const passthroughTargetFile = !isEmpty(
    get(fileUpload, "mappingConfiguration", {})
  )
    ? get(fileUpload, "mappingConfiguration.targetHeaderMapJson", {})
    : get(apiData, "targetHeaderMapJson");

  const outputTemplateMaps = !isEmpty(
    get(fileUpload, "mappingConfiguration", {})
  )
    ? get(fileUpload, "mappingConfiguration.outputTemplateMaps", [])
    : get(apiData, "outputTemplateMaps", []);
  const passthroughObjectMaps = outputTemplateMaps?.map((itm, ind) => {
    const [valueTransformations] = itm?.ValueTransformations;
    const [headerTransformations] = itm?.HeaderTransformations;
    return {
      fieldName: !isEmptyArray(itm?.HeaderTransformations)
        ? headerTransformations
        : `/${itm.Header}`,
      value: !isEmptyArray(itm?.ValueTransformations)
        ? valueTransformations
        : itm.PropertyName,
      order: itm.Order,
      isConfiguration: true,
      headerDataSource: itm?.HeaderDataSource,
      valueDataSource: !isEmptyArray(itm?.ValueTransformations)
        ? 2
        : itm?.ValueDataSource,
      isNewField:
        !isEmptyArray(itm?.HeaderTransformations) ||
        itm?.HeaderDataSource == 1 ||
        mappingData.targetField == 2
          ? true
          : false,
    };
  });
  const passthroughFileName = !isEmpty(
    get(fileUpload, "mappingConfiguration", {})
  )
    ? get(fileUpload, "mappingConfiguration.targetUploadedFileName", "")
    : get(apiData, "targetUploadedFileName");
  useEffect(() => {
    if (!isEmpty(passthroughTargetFile)) {
      setJsonPassthroughTargetFile(JSON.parse(passthroughTargetFile));
    }
  }, [passthroughTargetFile]);
  useDeepEffect(() => {
    if (!isEmpty(passthroughObjectMaps)) {
      if (!isEmpty(jsonPassthroughTargetFile)) {
        let tempTargetList = [
          ...jsonPassthroughTargetFile?.map((item) => {
            const temp = passthroughObjectMaps.find(
              (_) => _.order === item.order
            );
            if (!temp) return item;
            return {
              fieldName: temp.fieldName,
              value: temp.value,
              order: temp.order,
              isNewField: temp.isNewField,
              isConfiguration: temp.isConfiguration,
              headerDataSource: temp?.headerDataSource,
              valueDataSource: temp?.valueDataSource,
            };
          }),
          ...passthroughObjectMaps
            .filter(
              (x) =>
                !jsonPassthroughTargetFile.map((y) => y.order).includes(x.order)
            )
            .map((item) => ({
              fieldName: item.fieldName,
              value: item.value,
              order: item.order,
              isNewField: item.isNewField,
              isConfiguration: item.isConfiguration,
              headerDataSource: item?.headerDataSource,
              valueDataSource: item?.valueDataSource,
            })),
        ];
        tempTargetList = [
          ...tempTargetList,
          {
            order: tempTargetList?.length + 1,
            fieldName: "/FIELD NAME",
            isNewField: true,
          },
        ];
        setTargetList(tempTargetList);
      } else {
        const lastTargetIndex = passthroughObjectMaps?.length - 1;
        if (lastTargetIndex >= 0) {
          var lastObject = passthroughObjectMaps[lastTargetIndex];
        }
        setTargetList([
          ...passthroughObjectMaps,
          {
            order: lastObject?.order + 1,
            fieldName: "/FIELD NAME",
            isNewField: true,
          },
        ]);
      }
    } else {
      if (!isEmpty(jsonPassthroughTargetFile)) {
        setTargetList([
          ...jsonPassthroughTargetFile,
          {
            order: JSON.parse(passthroughTargetFile)?.length + 1,
            fieldName: "/FIELD NAME",
            isNewField: true,
          },
        ]);
      } else {
        setTargetList([
          {
            order: 1,
            fieldName: "/FIELD NAME",
            isNewField: true,
          },
        ]);
      }
    }
  }, [jsonPassthroughTargetFile, passthroughObjectMaps]);
  // useEffect(() => {
  //   const filteredTargetField = targetField?.filter((obj) => !obj.isCollection);
  //   if (isEmptyArray(mappingData?.objectMaps)) {
  //     if (
  //       mapType == 1 &&
  //       enableAutomapper &&
  //       (mappingData?.uploadedFileType == 1 ||
  //         mappingData?.uploadedFileType == 3)
  //     ) {
  //       if (!isEmpty(characters) && !isEmpty(targetField)) {
  //         var payload = {
  //           fieldName: characters?.map((data) =>
  //             data.fieldName.replaceAll("/", "")
  //           ),
  //           target: filteredTargetField?.map((data) => data.propertyName),
  //         };
  //         setDataLoading(true);
  //         getMappings(payload)
  //           .then((response) => {
  //             targetField.map((item) => {
  //               item.path = "/" + response?.getMappings[item.propertyName];
  //             });
  //             setDataLoading(false);
  //           })
  //           .catch((e) => {
  //             setDataLoading(false);
  //           });
  //       }
  //     }
  //   }
  // }, [characters]);
  useDeepEffect(() => {
    var initialTarget = !isEmpty(wholeObject)
      ? [...wholeObject, ...requiredCollections]
      : targetData;
    const filteredTargetField = initialTarget?.filter(
      (obj) => !obj.isCollection
    );
    if (isEmptyArray(mappingData?.objectMaps)) {
      if (
        mapType == 1 &&
        enableAutomapper &&
        (mappingData?.uploadedFileType == 1 ||
          mappingData?.uploadedFileType == 3)
      ) {
        setDataLoading(true);
        if (!isEmpty(characters) && !isEmpty(filteredTargetField)) {
          var payload = {
            fieldName: characters?.map((data) =>
              data.fieldName.replaceAll("/", "")
            ),
            target: filteredTargetField?.map((data) => data.propertyName),
          };
          getMappings(payload).then((response) => {
            initialTarget.map((item) => {
              item.path = "/" + response.getMappings[item.propertyName];
            });
            setDataLoading(false);
          });
        }
      }
    }
    setTargetField(initialTarget);
  }, [targetData]);
  const retrieveChildren = (targetField1) => {
    targetField1.map((e) => {
      if (e.isComplex === true) {
        children.push(e);
      }
      if (!isEmpty(e.childObjectMaps)) {
        retrieveChildren(e.childObjectMaps);
      }
    });
    return children;
  };

  const retrieveGroups = (targetField1) => {
    targetField1.map((e) => {
      if (e.isCollection === true) {
        gr.push(e);
      }
      if (!isEmpty(e.childObjectMaps)) {
        retrieveGroups(e.childObjectMaps);
      }
    });
    return gr;
  };
  const processChildObjectMapsRecursive = (childObjectMaps) => {
    return childObjectMaps.map((e) => {
      const filteredChildObjectMaps = processChildObjectMapsRecursive(
        get(e, "childObjectMaps", [])
      );

      if (
        !isEmpty(e.path) &&
        characters?.map((x) => x.fieldName).includes(e.path)
      ) {
        return {
          id: 0,
          constantValue: get(e, "constantValue", ""),
          childObjectMaps: filteredChildObjectMaps,
          dataType: e.dataType,
          displayName: e.displayName,
          dataSource: get(e, "dataSource", 1),
          fieldOperations:
            get(e, "dataSource", 1) == 3 ||
            (get(e, "fieldOperations", []).length == 1 &&
              get(e, "fieldOperations", [])[0].transformation == "")
              ? []
              : get(e, "fieldOperations", []),
          isCollection: get(e, "isCollection", false),
          isCollectionEnd: get(e, "isCollectionEnd", false),
          isCollectionStart: get(e, "isCollectionStart", false),
          isComplex: get(e, "isComplex", false),
          path: get(e, "path", null),
          propertyName: e.propertyName,
          sortOrder: e.sortOrder,
        };
      } else {
        return {
          ...e,
          id: 0,
          childObjectMaps: filteredChildObjectMaps,
        };
      }
    });
  };
  const deserialiseSftp = !isEmpty(get(mappingData, "outputProfile", ""))
    ? JSON.parse(get(mappingData, "outputProfile", ""))
    : null;
  const SaveMapping = () => {
    setmapperenable(false);
    const { history } = props;
    if (mapType == 3) {
      if (targetList.some((_) => _.isConfiguration == false)) {
        setIsRequiredPassthrough(true);
      } else {
        const payload = targetList?.filter((item) => {
          return item.value != undefined && { ...item };
        });
        const outputTemplateMap = payload?.map((outputTemplate) => {
          const setHeaderDataSource =
            outputTemplate?.headerDataSource == 3 ? 3 : 1;
          const setValueDataSource =
            outputTemplate?.valueDataSource == 3 ? 3 : 1;
          return {
            headerTransformations:
              outputTemplate?.headerDataSource == 2
                ? [outputTemplate?.fieldName]
                : [],
            valueTransformations:
              outputTemplate?.valueDataSource == 2
                ? [outputTemplate?.value]
                : [],
            propertyName:
              outputTemplate?.valueDataSource != 2
                ? outputTemplate?.value
                : "/TRANSFORMATION",
            isComplex: false,
            isCollection: false,
            order: outputTemplate.order,
            headerDataSource: setHeaderDataSource,
            valueDataSource: setValueDataSource,
            header: passthroughStringToFunctionConverter(
              removePassthroughFieldTrans(outputTemplate?.fieldName),
              characters,
              0
            ),
            value:
              outputTemplate?.valueDataSource == 3
                ? outputTemplate?.value.slice(1, -1)
                : null,
            targetHeader:
              outputTemplate?.headerDataSource == 1
                ? outputTemplate?.fieldName
                : null,
            childObjectMaps: null,
            isCollectionStart: false,
            isCollectionEnd: false,
          };
        });
        if (apiData?.targetField == 2 && isEmpty(payload)) {
          setShowToast(true);
        }
        if (!isEmpty(payload)) {
          setDataLoading(true);
          savePassthroughMapAndTransform({
            profileId: parseInt(profileId),
            saveMappingPayload: {
              type:
                mappingData.targetFileFormat == 1 ||
                mappingData.targetFileFormat == 14
                  ? 0
                  : mappingData.targetFileFormat == 3
                  ? 2
                  : null,
              delimiter:
                mappingData.targetFileFormat == 1 ||
                mappingData.targetFileFormat == 14
                  ? ","
                  : null,
              SFTPHost: get(deserialiseSftp, "SFTPHost", null),
              SFTPUserName: get(deserialiseSftp, "SFTPUserName", null),
              SFTPPassword: get(deserialiseSftp, "SFTPPassword", null),
              SFTPPath: get(deserialiseSftp, "SFTPPath", null),
              outputTemplateMaps: outputTemplateMap,
            },
          })
            .then((response) => {
              if (!isEmpty(response)) {
                const outputTemplateMaps = JSON.parse(
                  response["outputProfile"]
                )["OutputTemplateMaps"];
                response = { ...response, outputTemplateMaps };
                dispatch(setMapperPostResponse(response));
                if (!isEmpty(fileUpload)) {
                  dispatch(
                    setFileUploadData({
                      row: get(state, "api.fileuploadData.row", []),
                      mappingConfiguration: response,
                    })
                  );
                }

                dispatch(
                  setManageMapperToastInfo({
                    showToast: true,
                    toastMessage: "Data saved successfully",
                  })
                );
                history.push(
                  `${MANAGE_MAPPER_ROUTES.VALIDATIONS}/${mapType}/${profileId}`
                );
                return null;
              } else {
                dispatch({
                  type: MANAGE_MAPPER_POST_API_ERROR,
                  payload: "Something went wrong! please try again.",
                });
              }
              setDataLoading(false);
            })
            .catch((error) => {
              setDataLoading(false);
              dispatch({
                type: MANAGE_MAPPER_POST_API_ERROR,
                payload: "Something went wrong! please try again.",
              });
            });
        }
      }
    } else {
      const groupItems = targetField.filter((e) => e.isCollection);
      const groups = groupItems
        .map((e) => {
          if (!isEmpty(e.childObjectMaps)) {
            return {
              id: 0,
              constantValue:
                e.dataType === 4
                  ? e.constantValue
                  : e["constantValue"]?.toLowerCase() === "@filename"
                  ? "@FileName"
                  : "",
              dataSource: get(e, "dataSource", 1),
              fieldOperations: [],
              isCollection: e.isCollection,
              isCollectionEnd: e.isCollectionEnd,
              displayName: e.displayName,
              isCollectionStart: e.isCollectionStart,
              isComplex: get(e, "isComplex", false),
              propertyName: e.propertyName,
              sortOrder: e.sortOrder,
              childObjectMaps: processChildObjectMapsRecursive(
                e.childObjectMaps
              ),
            };
          }
        })
        .filter((f) => !isEmpty(f?.childObjectMaps));
      const childrenItems = targetField.filter((e) => e.isComplex === true);
      const childrens = childrenItems
        .map((e) => {
          if (!isEmpty(e.childObjectMaps)) {
            return {
              id: 0,
              constantValue:
                e.dataType === 4
                  ? e.constantValue
                  : e["constantValue"]?.toLowerCase() === "@filename"
                  ? "@FileName"
                  : "",
              dataSource: get(e, "dataSource", 1),
              fieldOperations: [],
              isCollection: e.isCollection,
              isCollectionEnd: e.isCollectionEnd,
              isCollectionStart: e.isCollectionStart,
              isComplex: get(e, "isComplex", false),
              displayName: e.displayName,
              propertyName: e.propertyName,
              sortOrder: e.sortOrder,
              childObjectMaps: processChildObjectMapsRecursive(
                e.childObjectMaps
              ),
            };
          }
        })
        .filter((f) => !isEmpty(f?.childObjectMaps));

      const requiredFields =
        !isEmpty(targetField) &&
        targetField
          .filter((e) => !isEmpty(e.path))
          .map((e) => ({
            id: 0,
            constantValue:
              e.dataType === 4
                ? e.constantValue
                : e["constantValue"]?.toLowerCase() === "@filename"
                ? "@FileName"
                : e["constantValue"],
            childObjectMaps: get(e, "childObjectMaps", []),
            dataType: e.dataType,
            displayName: e.displayName,
            dataSource: get(e, "dataSource", 1),
            fieldOperations:
              get(e, "dataSource", 1) == 3 ||
              (get(e, "fieldOperations", []).length == 1 &&
                get(e, "fieldOperations", [])[0].transformation == "")
                ? []
                : get(e, "fieldOperations", []),
            isCollection: e.isCollection,
            isCollectionEnd: get(e, "isCollectionEnd", false),
            isCollectionStart: get(e, "isCollectionStart", false),
            isComplex: get(e, "isComplex", false),
            path: get(e, "path", null),
            propertyName: e.propertyName,
            sortOrder: e.sortOrder,
          }));
      const ids = groups.map((_) => _?.id);
      const filteredRequiredFields = requiredFields?.filter(
        (_) => !ids.includes(_?.id) || _?.id == 0
      );
      const finalFields = filteredRequiredFields.filter((f) =>
        characters
          ?.map((x) => x.fieldName?.replaceAll("/", ""))
          .includes(f.path?.replaceAll("/", ""))
      );

      function getTopLevelObjectsWithData(jsonData) {
        const topLevelObjects = [];

        function hasDataInChildObjectMaps(childObjectMaps, parentPath) {
          return childObjectMaps.some((childObjectMap) => {
            if (childObjectMap.path) {
              return true;
            }
            if (childObjectMap.childObjectMaps) {
              return hasDataInChildObjectMaps(
                childObjectMap.childObjectMaps,
                childObjectMap.path || parentPath
              );
            }
            return false;
          });
        }

        function filterChildObjectMaps(childObjectMaps, parentPath) {
          return childObjectMaps.filter((childObjectMap) => {
            if (
              childObjectMap.path ||
              hasDataInChildObjectMaps(
                childObjectMap.childObjectMaps,
                parentPath
              )
            ) {
              if (childObjectMap.childObjectMaps) {
                childObjectMap.childObjectMaps = filterChildObjectMaps(
                  childObjectMap.childObjectMaps,
                  childObjectMap.path || parentPath
                );
              }
              return true;
            }
            return false;
          });
        }

        jsonData.forEach((topLevelObject) => {
          topLevelObject.childObjectMaps = filterChildObjectMaps(
            topLevelObject.childObjectMaps,
            ""
          );
          if (hasDataInChildObjectMaps(topLevelObject.childObjectMaps, "")) {
            topLevelObjects.push(topLevelObject);
          }
        });

        return topLevelObjects;
      }

      const topLevelObjectsWithData = getTopLevelObjectsWithData(groups);
      const topLevelObjectsWithData1 = getTopLevelObjectsWithData(childrens);

      const payload = {
        ...get(state, "api.data"),
        objectMaps: [
          ...finalFields,
          ...topLevelObjectsWithData,
          ...topLevelObjectsWithData1,
        ],
      };

      let isSsnExists = !isEmpty(
        payload?.objectMaps?.filter(
          (item) => item?.propertyName == "UniquePersonalIdentification"
        )
      );
      let isRkPlanNumberExists = !isEmpty(
        payload?.objectMaps?.filter(
          (item) => item?.propertyName == "RKPlanNumber"
        )
      );
      if (
        (isSsnExists && isRkPlanNumberExists) ||
        uploadedFileType === 8 ||
        uploadedFileType === 9
      ) {
        setDataLoading(true);
        dispatch(setMapperPostRequest());
        onMappingChange(payload)
          .then((res) => {
            setDataLoading(false);

            if (!isEmpty(res)) {
              history.push(
                `${MANAGE_MAPPER_ROUTES.VERIFY_MAP}/${mapType}/${profileId}`
              );
              dispatch(setMapperPostResponse(res));
              if (!isEmpty(fileUpload)) {
                dispatch(
                  setFileUploadData({
                    row: get(state, "api.fileuploadData.row", []),
                    mappingConfiguration: res,
                  })
                );
              }

              dispatch(
                setManageMapperToastInfo({
                  showToast: true,
                  toastMessage: "Data saved successfully",
                })
              );
              return null;
            } else {
              dispatch({
                type: MANAGE_MAPPER_POST_API_ERROR,
                payload: "Something went wrong! please try again.",
              });
            }
          })
          .catch((err) => {
            setDataLoading(false);
            dispatch({
              type: MANAGE_MAPPER_POST_API_ERROR,
              payload: "Something went wrong! please try again.",
            });
          });
      } else {
        setSsnExist(false);
        setRkPlanNumberExist(false);
      }
    }
  };
  const buttons = [
    {
      label: "Cancel",
      variant: "secondary",
      type: "button",
      onClick: () => {
        setModalVisible(true);
      },
      // link: ROUTES.MAPPER_HOME,
    },
    {
      label: "Next",
      variant: "primary",
      type: "submit",
      onClick: SaveMapping,
    },
    // {
    //   label: "ai",
    //   variant: "primary",
    //   type: "submit",
    //   onClick: () => {
    //     setailoader(!ailoader);
    //   },
    // },
  ];

  const onCancelConfigure = () => {
    setConfigureSlider(false);
  };
  const history = useHistory();
  const navigateToMapperHomePage = () => {
    history.push(
      getPathWithParam({
        path: `${ROUTES.MAPPER_HOME}`,
      })
    );
  };

  const setConfigure = () => {
    //setConfigureSlider(!addConfigureSlider);
  };

  const handleOnDragStart = () => {
    if (mapType != 3) {
      setDrag(true);
    }
  };
  const handleOnDragUpdate = (update) => {
    if (mapType != 3) {
      const { destination } = update;
      if (!isNull(destination)) {
        setDestination(destination.droppableId);
      }
    }
  };

  const handleOnDragEnd = (result) => {
    setDrag(false);
    setDestination(null);
    const { source, destination } = result;
    if (isEmpty(result.destination)) {
      setDestination("");
      return;
    }
    if (mapType == 3) {
      const findIndex = targetList.find(
        (f) => f.order == destination.droppableId
      );
      const currentIndex = targetList.findIndex((element, index) => {
        return element?.order === findIndex?.order;
      });
      const draggedData = targetList.map((e, i) => {
        if (e.order == destination.droppableId) {
          return {
            ...e,
            value: characters.find((f) => f.fieldName == result.draggableId)
              .fieldName,
            isConfiguration: true,
            fieldName: e?.isNewField
              ? characters.find((f) => f.fieldName == result.draggableId)
                  .fieldName
              : e.fieldName,
            headerDataSource: e?.isNewField ? 1 : 3,
            valueDataSource: 1,
          };
        }
        return e;
      });
      if (targetList?.length == currentIndex + 1) {
        setSearchList([
          ...draggedData,
          {
            order: findIndex?.order + 1,
            fieldName: "/FIELD NAME",
            isNewField: true,
          },
        ]);
        setTargetList([
          ...draggedData,
          {
            order: findIndex?.order + 1,
            fieldName: "/FIELD NAME",
            isNewField: true,
          },
        ]);
      } else {
        setSearchList(draggedData);
        setTargetList(draggedData);
      }
    } else {
      const draggedData = destination.droppableId.includes(",")
        ? targetField.map((e, i) => {
            if (destination.droppableId.includes(",")) {
              const Tids = destination.droppableId.split(",");
              const updatedE = recursivelyUpdateChildObjectMaps(
                e,
                Tids,
                result
              );
              return updatedE;
            }
            return e;
          })
        : targetField.map((e, i) => {
            if (e.id == destination.droppableId) {
              return {
                ...e,
                path: characters.find((f) => f.fieldName == result.draggableId)
                  .fieldName,
                constantValue: null,
                dataSource: 1,
                fieldOperations: [],
                resultArray: [],
                variableValue: null,
                targetFieldName: null,
                targetFieldRename: null,
              };
            }
            return e;
          });
      setTargetField(draggedData);
    }
  };

  function recursivelyUpdateChildObjectMaps(parentObject, Tids, result) {
    if (parentObject.id == Tids[1]) {
      const childMaps = parentObject.childObjectMaps.map((f) =>
        f.id == Tids[0]
          ? {
              ...f,
              path: characters.find((g) => g.fieldName == result.draggableId)
                .fieldName,
              constantValue: null,
              dataSource: 1,
              fieldOperations: [],
              resultArray: [],
              variableValue: null,
              targetFieldName: null,
              targetFieldRename: null,
            }
          : f
      );
      return {
        ...parentObject,
        childObjectMaps: childMaps,
      };
    } else {
      const updatedChildMaps = parentObject.childObjectMaps.map((child) =>
        recursivelyUpdateChildObjectMaps(child, Tids, result)
      );
      return {
        ...parentObject,
        childObjectMaps: updatedChildMaps,
      };
    }
  }
  const setFieldOperations = (dataSource, operations, itemConfigures) => {
    const itemConfigure = itemConfigures.object;
    const transformations =
      !isEmpty(ct) && ct.length > 1
        ? !isEmpty(ct.find((e) => e.propertyName == itemConfigure.propertyName))
          ? ct.map((e, i) => {
              if (e.propertyName == itemConfigure.propertyName) {
                return {
                  id: e.id,
                  isCollection: e.isCollection,
                  isCollectionStart: e.isCollectionStart,
                  isCollectionEnd: e.isCollectionEnd,
                  groupName: e.groupName,
                  displayName: e.displayName,
                  propertyName: e.propertyName,
                  dataType: e.dataType,
                  format: e.format,
                  fieldLength: e.fieldLength,
                  isRequired: e.isRequired,
                  childObjectMaps: e.childObjectMaps,
                  fieldOperations: operations,
                  isComplex: e.isComplex,
                  mappingConfigurationId: get(state, "api.data.id", 0),
                  parent: e.parent,
                  parentId: e.parentId,
                  path: e.path,
                  sortOrder: e.sortOrder,
                  index: e.index,
                  constantValue: e.constantValue,
                  dataSource: dataSource,
                };
              }
              return e;
            })
          : [
              ...ct,
              {
                id: itemConfigure.id,
                isCollection: itemConfigure.isCollection,
                isCollectionStart: itemConfigure.isCollectionStart,
                isCollectionEnd: itemConfigure.isCollectionEnd,
                groupName: itemConfigure.groupName,
                displayName: itemConfigure.displayName,
                propertyName: itemConfigure.propertyName,
                dataType: itemConfigure.dataType,
                format: itemConfigure.format,
                fieldLength: itemConfigure.fieldLength,
                isRequired: itemConfigure.isRequired,
                childObjectMaps: itemConfigure.childObjectMaps,
                fieldOperations: operations,
                isComplex: itemConfigure.isComplex,
                mappingConfigurationId: get(state, "api.data.id", 0),
                parent: itemConfigure.parent,
                parentId: itemConfigure.parentId,
                path: itemConfigure.path,
                sortOrder: itemConfigure.sortOrder,
                index: itemConfigure.index,
                constantValue: itemConfigure.constantValue,
                dataSource: dataSource,
              },
            ]
        : isEmpty(ct)
        ? [
            {
              id: itemConfigure.id,
              isCollection: itemConfigure.isCollection,
              isCollectionStart: itemConfigure.isCollectionStart,
              isCollectionEnd: itemConfigure.isCollectionEnd,
              groupName: itemConfigure.groupName,
              displayName: itemConfigure.displayName,
              propertyName: itemConfigure.propertyName,
              dataType: itemConfigure.dataType,
              format: itemConfigure.format,
              fieldLength: itemConfigure.fieldLength,
              isRequired: itemConfigure.isRequired,
              childObjectMaps: itemConfigure.childObjectMaps,
              fieldOperations: operations,
              isComplex: itemConfigure.isComplex,
              mappingConfigurationId: get(state, "api.data.id", 0),
              parent: itemConfigure.parent,
              parentId: itemConfigure.parentId,
              path: itemConfigure.path,
              sortOrder: itemConfigure.sortOrder,
              index: itemConfigure.index,
              constantValue: itemConfigure.constantValue,
              dataSource: dataSource,
            },
          ]
        : ct.find((e) => e.propertyName == itemConfigure.propertyName)
        ? [
            {
              id: itemConfigure.id,
              isCollection: itemConfigure.isCollection,
              isCollectionStart: itemConfigure.isCollectionStart,
              isCollectionEnd: itemConfigure.isCollectionEnd,
              groupName: itemConfigure.groupName,
              displayName: itemConfigure.displayName,
              propertyName: itemConfigure.propertyName,
              dataType: itemConfigure.dataType,
              format: itemConfigure.format,
              fieldLength: itemConfigure.fieldLength,
              isRequired: itemConfigure.isRequired,
              childObjectMaps: itemConfigure.childObjectMaps,
              fieldOperations: operations,
              isComplex: itemConfigure.isComplex,
              mappingConfigurationId: get(state, "api.data.id", 0),
              parent: itemConfigure.parent,
              parentId: itemConfigure.parentId,
              path: itemConfigure.path,
              sortOrder: itemConfigure.sortOrder,
              index: itemConfigure.index,
              constantValue: itemConfigure.constantValue,
              dataSource: dataSource,
            },
          ]
        : [
            ...ct,
            {
              id: itemConfigure.id,
              isCollection: itemConfigure.isCollection,
              isCollectionStart: itemConfigure.isCollectionStart,
              isCollectionEnd: itemConfigure.isCollectionEnd,
              groupName: itemConfigure.groupName,
              displayName: itemConfigure.displayName,
              propertyName: itemConfigure.propertyName,
              dataType: itemConfigure.dataType,
              format: itemConfigure.format,
              fieldLength: itemConfigure.fieldLength,
              isRequired: itemConfigure.isRequired,
              childObjectMaps: itemConfigure.childObjectMaps,
              fieldOperations: operations,
              isComplex: itemConfigure.isComplex,
              mappingConfigurationId: get(state, "api.data.id", 0),
              parent: itemConfigure.parent,
              parentId: itemConfigure.parentId,
              path: itemConfigure.path,
              sortOrder: itemConfigure.sortOrder,
              index: itemConfigure.index,
              constantValue: itemConfigure.constantValue,
              dataSource: dataSource,
            },
          ];

    setCT(transformations);
  };
  const hasMatchingChildObjectMaps = (field, fieldName) => {
    if (field.path?.replaceAll("/", "") === fieldName.replaceAll("/", "")) {
      return true;
    }

    if (field.childObjectMaps && field.childObjectMaps.length > 0) {
      return field.childObjectMaps.some((child) =>
        hasMatchingChildObjectMaps(child, fieldName)
      );
    }

    return false;
  };
  const hasMatchingChildObjectMaps1 = (field, fieldName) => {
    if (field.path?.replaceAll("/", "") === fieldName.replaceAll("/", "")) {
      return true;
    }

    if (field.childObjectMaps && field.childObjectMaps.length > 0) {
      return field.childObjectMaps.some((child) =>
        hasMatchingChildObjectMaps(child, fieldName)
      );
    }

    return false;
  };
  return (
    <>
      {
        <LoaderWrapper isLoading={dataLoading} isAutoMapper={mapperenable}>
          <FormLeaveGuard
            showModal={modalVisible}
            handleConfirmClick={() => navigateToMapperHomePage()}
            handleCancelClick={() => setModalVisible(false)}
          />
          <ManageMapperLayout buttons={buttons}>
            <Formik
              initialValues={{}}
              enableReinitialize
              onSubmit={() => {}}
              validateOnChange={false}
              validateOnBlur={false}
            >
              {({
                errors,
                values,
                touched,
                setValues,
                handleChange,
                setFieldValue,
                handleSubmit,
              }) => {
                return (
                  <DragDropContext
                    onDragStart={handleOnDragStart}
                    onDragUpdate={handleOnDragUpdate}
                    onDragEnd={handleOnDragEnd}
                  >
                    <div
                      className={
                        mapType == 3
                          ? "passthrough-mapper-container mt-2 mb-3"
                          : "mapper-container marg-top-30"
                      }
                    >
                      <Row>
                        <Col
                          sm={mapType == 3 ? 5 : 4}
                          xs={mapType == 3 ? 5 : 4}
                          md={mapType == 3 ? 5 : 4}
                          lg={mapType == 3 ? 5 : 4}
                        >
                          <SourceContainer
                            column={get(columns, "source.id")}
                            setCharacters={setCharacters}
                            mapped={mapped}
                            characters={
                              characters
                                ? characters.map((e) => {
                                    const filtered = targetField.filter(
                                      (f) =>
                                        f.path?.replaceAll("/", "") ==
                                        e.fieldName?.replaceAll("/", "")
                                    );
                                    const groups = targetField
                                      .filter((f) => f.isCollection)
                                      .map((g) =>
                                        hasMatchingChildObjectMaps(
                                          g,
                                          e.fieldName
                                        )
                                      );
                                    const childrens = targetField
                                      .filter((f) => f.isComplex)
                                      .map((g) =>
                                        hasMatchingChildObjectMaps(
                                          g,
                                          e.fieldName
                                        )
                                      );
                                    if (
                                      !isEmpty(filtered) ||
                                      groups.includes(true) ||
                                      childrens.includes(true)
                                    ) {
                                      return {
                                        ...e,
                                        mapped: true,
                                      };
                                    }
                                    return e;
                                  })
                                : []
                            }
                            data={mappingData}
                          />
                        </Col>
                        <Col
                          sm={mapType == 3 ? 7 : 8}
                          xs={mapType == 3 ? 7 : 8}
                          md={mapType == 3 ? 7 : 8}
                          lg={mapType == 3 ? 7 : 8}
                        >
                          {mapType == 3 ? (
                            <>
                              <PassthroughTargetContainer
                                mappingData={mappingData}
                                isRequiredPassthrough={isRequiredPassthrough}
                                searchList={searchList}
                                setSearchList={setSearchList}
                                list={targetList}
                                setList={setTargetList}
                                passthroughFileName={passthroughFileName}
                                sorceData={characters}
                              />
                            </>
                          ) : (
                            !isEmpty(targetField) && (
                              <TargetContainer
                                configurations={ct} //
                                destination={dest}
                                requiredData={targetField}
                                setFieldOperations={setFieldOperations} //
                                addConfigureSlider={addConfigureSlider}
                                onCancelConfigure={onCancelConfigure}
                                setConfigure={setConfigure}
                                deleteCT={setCT}
                                setTargetField={setTargetField}
                                ssnExist={ssnExist}
                                rkPlanNumberExist={rkPlanNumberExist}
                                dragStart={dragStart}
                                characters={characters}
                                handleOnDragEnd={handleOnDragEnd}
                                fileName={mappingData.fileName}
                                uploadedFileType={uploadedFileType}
                              />
                            )
                          )}
                        </Col>
                      </Row>
                    </div>
                  </DragDropContext>
                );
              }}
            </Formik>
          </ManageMapperLayout>
          <WarningModal show={showToast} onHide={() => setShowToast(false)}>
            <div className="remove-text">
              <p>Kindly configure a field to process.</p>
              <Button
                className="remove-btn mr-4"
                onClick={() => setShowToast(false)}
              >
                Ok
              </Button>
            </div>
          </WarningModal>
        </LoaderWrapper>
      }
    </>
  );
};

export default MapperContainer;
